import React from 'react'
import { FaIcon, faClose } from '@/lib/fa'
import ModalLayout from '@/modules/drivers/modals/shared/ModalLayout'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type TimesheetInfoPopupProps = {
  onClose: () => void
  onCalculate: () => void
}

const TimesheetInfoPopup: React.FC<TimesheetInfoPopupProps> = ({
  onClose,
  onCalculate,
}) => {
  const reCalculateTimesheet = () => {
    onCalculate()
    onClose()
  }
  const { t } = useLocalize()
  return (
    <ModalLayout customZIndex={9999}>
      <div className="tw-fixed tw-inset-0 tw-z-[9998]" onClick={onClose}>
        <div
          className="tw-fixed tw-left-1/2 tw-top-1/2 tw-z-[9999] tw--translate-x-1/2 tw--translate-y-1/2"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="tw-flex tw-w-[500px] tw-flex-col tw-gap-3 tw-rounded-lg tw-bg-white tw-p-4 tw-shadow-lg">
            <div className="tw-flex tw-items-center tw-justify-between">
              <h2 className="tw-text-xl tw-font-semibold tw-text-content-amber">
                {t('timesheet.settings-changed-title')}
              </h2>
              <FaIcon
                icon={faClose}
                onClick={onClose}
                className="tw-h-5 tw-w-5 tw-cursor-pointer"
              />
            </div>
            <p className="tw-m-0 tw-text-sm tw-text-content-base/80">
              {t('timesheet.settings-changed-info')}
            </p>
            <div className="tw-flex tw-items-center tw-justify-between">
              <button
                onClick={onClose}
                className={`tw-cursor-pointer tw-rounded-lg tw-border tw-border-primary tw-bg-secondary tw-p-3 tw-text-sm tw-font-medium tw-text-primary hover:tw-opacity-80`}
              >
                {t('timesheet.recalculate-later')}
              </button>
              <button
                onClick={() => reCalculateTimesheet()}
                className={`tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80`}
              >
                {t('timesheet.recalculate-now')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ModalLayout>
  )
}

export default TimesheetInfoPopup
